import React from 'react'

import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import { CalendaredRentPriceTypeOption } from '../../../../../../../@types/dropdown-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'

const optionKeys = Object.keys(CalendaredRentPriceTypeOption)

const PricePeriodTypeChips: React.FC<FieldProps<BasicInfoScreenValidationResult>> = ({
  screenName,
  insertionData,
  onChange,
  wrapperClassName,
}) => {
  const property = 'pricePeriodType'
  const value = insertionData.pricePeriodType?.value ?? undefined

  return (
    <div className={wrapperClassName}>
      <ChipOptionField
        id='price-type'
        propertyName='pricePeriodType'
        option={value}
        options={optionKeys}
        isFirstChipFiltered={false}
        enableDeselection={false}
        translation={'wizard.screen.costs.pricePeriodTypeOptions.'}
        labelTranslationKey={'wizard.screen.costs.pricePeriodTypeLabel'}
        onChange={(value: string) => {
          onChange({ screen: screenName, property }, { value, label: undefined })
        }}
      />
    </div>
  )
}

export default PricePeriodTypeChips
